/*
 * Size chart modal: open/close (button, overlay, ESC), basic focus handling,
 * and an imperial/metric unit toggle that swaps each cell's value in place.
 * Server-rendered content (imperial by default) so it stays crawlable.
 */
(function () {
  var lastFocused = null;

  // The modal is rendered inside the product info column, whose sticky/transformed
  // ancestors trap `position: fixed`. Move it to <body> so it overlays the whole
  // window and centers on the viewport, not the column.
  function portalModals() {
    var modals = document.querySelectorAll('.size-chart');
    for (var i = 0; i < modals.length; i++) {
      if (modals[i].parentNode !== document.body) document.body.appendChild(modals[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalModals);
  } else {
    portalModals();
  }

  // Prev/next controls for the swipeable table: show the pair only when the
  // table actually overflows, and disable each button at its respective end.
  // A generous tolerance (rather than 1px) avoids false positives from
  // Safari's sticky-table-cell subpixel rounding, which reports a few px of
  // "overflow" even when every column is fully visible.
  function updateScrollButtons(modal) {
    var wrap = modal.querySelector('[data-size-chart-scroll]');
    var controls = modal.querySelector('[data-size-chart-scroll-controls]');
    var prevBtn = modal.querySelector('[data-size-chart-scroll-prev]');
    var nextBtn = modal.querySelector('[data-size-chart-scroll-next]');
    if (!wrap || !controls || !prevBtn || !nextBtn) return;
    var maxScroll = wrap.scrollWidth - wrap.clientWidth;
    var overflow = maxScroll > 12;
    controls.hidden = !overflow;
    if (!overflow) {
      // Reset so a later reflow that brings overflow back doesn't inherit a
      // stale "next" state from before the table last settled.
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }
    prevBtn.disabled = wrap.scrollLeft <= 1;
    nextBtn.disabled = wrap.scrollLeft >= maxScroll - 1;
  }

  function bindScrollButtons(modal) {
    var wrap = modal.querySelector('[data-size-chart-scroll]');
    var table = wrap ? wrap.querySelector('.size-chart__table') : null;
    var prevBtn = modal.querySelector('[data-size-chart-scroll-prev]');
    var nextBtn = modal.querySelector('[data-size-chart-scroll-next]');
    if (!wrap || wrap.dataset.scrollButtonsBound) return;
    wrap.dataset.scrollButtonsBound = 'true';
    wrap.addEventListener('scroll', function () { updateScrollButtons(modal); });
    window.addEventListener('resize', function () { updateScrollButtons(modal); });
    // The initial check runs before web fonts finish loading, so it can measure
    // a fallback-font-width table that overflows when the final rendered table
    // doesn't. Recheck once real layout settles instead of trusting one snapshot.
    if (table && window.ResizeObserver) {
      new ResizeObserver(function () { updateScrollButtons(modal); }).observe(table);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { updateScrollButtons(modal); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: -wrap.clientWidth * 0.75, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: wrap.clientWidth * 0.75, behavior: 'smooth' });
      });
    }
  }

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    bindScrollButtons(modal);
    // next frame so the transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        updateScrollButtons(modal);
      });
    });
    document.body.style.overflow = 'hidden';
    var close = modal.querySelector('.size-chart__close');
    if (close) close.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener('transitionend', done);
    };
    modal.addEventListener('transitionend', done);
    // Fallback in case transitionend doesn't fire (reduced motion, etc.)
    setTimeout(function () { modal.hidden = true; }, 300);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.size-chart.is-open');
      if (open) closeModal(open);
    }
  }

  function setUnit(modal, unit) {
    var cells = modal.querySelectorAll('.size-chart__table td[data-' + unit + ']');
    for (var i = 0; i < cells.length; i++) {
      var v = cells[i].getAttribute('data-' + unit);
      if (v !== null) cells[i].textContent = v;
    }
    var buttons = modal.querySelectorAll('.size-chart__unit');
    for (var j = 0; j < buttons.length; j++) {
      var active = buttons[j].getAttribute('data-size-chart-unit') === unit;
      buttons[j].classList.toggle('is-active', active);
      buttons[j].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-chart-open]');
    if (opener) {
      e.preventDefault();
      openModal(document.getElementById(opener.getAttribute('data-size-chart-open')));
      return;
    }
    if (e.target.closest('[data-size-chart-close]')) {
      closeModal(e.target.closest('.size-chart'));
      return;
    }
    var unitBtn = e.target.closest('[data-size-chart-unit]');
    if (unitBtn) {
      var unitModal = unitBtn.closest('.size-chart');
      setUnit(unitModal, unitBtn.getAttribute('data-size-chart-unit'));
      updateScrollButtons(unitModal);
    }
  });
})();
